import { CompanyService } from "../../../services/CompanyService";

const updateEmailList = async function ({ commit, dispatch, state }, config) {
    const { companyId, emailList, defaultEmail } = config
    const data = await CompanyService.updateEmailList(companyId, emailList, defaultEmail);
    return data;
};

export default updateEmailList;